<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        medienform: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() => (props.language === 'englisch' ? 'Types of media used | Medienform' : 'Medienform'))

    const emit = defineEmits(['medienformSaved'])

    let editMedienform = ref('')

    function handleEditStart() {
        editMedienform.value = props.medienform
    }

    function handleEditAbort() {
        editMedienform.value = ''
    }

    const saveMedienform = () => {
        emit('medienformSaved', editMedienform.value)
    }
</script>

<template>
    <common-single-edit
        :entry="medienform"
        edit-key="medienform"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveMedienform"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editMedienform" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="medienform" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
